<template>
  <div>
    <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
      <v-avatar>
        <v-icon> equalizer </v-icon>
      </v-avatar>
      {{trans.ntrans}}
    </v-chip>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
export default {
  mixins: [apptheme],
  computed: {
    ...mapGetters(["getTransitions"]),
    trans() {
      return this.getTransitions;
    }
  }
};
</script>
